import { Box, Button, makeStyles } from "@material-ui/core";
import React from "react";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import ChangeHistoryIcon from "@material-ui/icons/ChangeHistory";
import { useDispatch, useSelector } from "react-redux";
import { setCurrSettings } from "redux/actions/FormBuilder";
import MessageIcon from "@material-ui/icons/Message";
import DashboardIcon from "@material-ui/icons/Dashboard";

const useStyles = makeStyles((_) => ({
  fieldButton: {
    width: "100%",
    marginBottom: "16px",
  },
}));

const SettingsSelector = () => {
  const dispatch = useDispatch();
  const { currSettings, formSettings } = useSelector(
    ({ formBuilder }) => formBuilder
  );

  const { formType } = formSettings;

  const classes = useStyles();
  return (
    <Box width={"100%"}>
      <Button
        variant="contained"
        color={currSettings === "GENERAL" ? "secondary" : "primary"}
        startIcon={<CheckBoxOutlineBlankIcon />}
        className={classes.fieldButton}
        onClick={() => dispatch(setCurrSettings("GENERAL"))}
      >
        تنظیمات عمومی
      </Button>
      <Button
        variant="contained"
        color={currSettings === "LIMIT" ? "secondary" : "primary"}
        startIcon={<ChangeHistoryIcon />}
        className={classes.fieldButton}
        onClick={() => dispatch(setCurrSettings("LIMIT"))}
      >
        تنظیمات محدودیت
      </Button>
      <Button
        variant="contained"
        color={currSettings === "CONFIRM_MESSAGE" ? "secondary" : "primary"}
        startIcon={<MessageIcon />}
        className={classes.fieldButton}
        onClick={() => dispatch(setCurrSettings("CONFIRM_MESSAGE"))}
      >
        پیام های تایید
      </Button>
      {formType === "Exam" && (
        <Button
          variant="contained"
          color={currSettings === "EXAM_SETTINGS" ? "secondary" : "primary"}
          startIcon={<DashboardIcon />}
          className={classes.fieldButton}
          onClick={() => dispatch(setCurrSettings("EXAM_SETTINGS"))}
        >
          تنظیمات آزمون
        </Button>
      )}
    </Box>
  );
};

export default SettingsSelector;
